export class PLBidderRegistration {
    Ind: number;
    OrgCode: number;
    CityCode: number;
    LegalStatusCd: number;
    CompanyName: string;
    RegistrationNo: string;
    EstbYear: string;
    RegisteredAddress: string;
    FirmCity: string;
    PostalCode: string;
    PanNo: string;
    GstNo: string;
    NameOfAuthorizedReprestator: string;
    MobileNo: string;
    Designation: string;
    Email: string;
    BankName: string;
    BranchName: string;
    NameAsInBankAccount: string;
    AccountNo: string;
    IfscCode: string;
    RegAmount: number;
    RegImageUploadList: any = [];


     //For GST
     CGSTAmount: number;
     SGSTAmount: number;
}
